var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("会社概要")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [_c("dd-menu", { ref: "menuRef" }), _vm._v(" "), _vm._m(0)],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "corp_information" } }, [
      _c("section", [
        _c("ul", { staticClass: "ul_corp_outline" }, [
          _c("li", [
            _c("div", [_vm._v("会社名")]),
            _vm._v(" "),
            _c("div", [_vm._v("株式会社ヤスモク")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("本社")]),
            _vm._v(" "),
            _c("div", [
              _vm._v("\n                〒501-4202 岐阜県郡上市八幡町市島18-1"),
              _c("br"),
              _vm._v(
                "\n                TEL 0575-62-2311 FAX 0575-62-2227\n              "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("代表者")]),
            _vm._v(" "),
            _c("div", [_vm._v("代表取締役 安田知弘")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("資本金")]),
            _vm._v(" "),
            _c("div", [_vm._v("2500万円")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("設立")]),
            _vm._v(" "),
            _c("div", [_vm._v("1974年6月10日（昭和49年6月10日）")])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("事業内容")]),
            _vm._v(" "),
            _c("div", [
              _vm._v("\n                住宅関連木製品の製造販売"),
              _c("br"),
              _vm._v(
                "\n                （システムキッチン・ウッドデッキ・インテリア・エクステリア関連商品・その他木製品）\n              "
              )
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("div", [_vm._v("交通アクセス")]),
            _vm._v(" "),
            _c("div", { staticClass: "traficc_access_list" }, [
              _c("div", [
                _c("p", [
                  _vm._v("本社（岐阜）：〒501-4202 岐阜県郡上市八幡町市島18-1")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gmap" }, [
                  _c("iframe", {
                    staticStyle: { border: "0" },
                    attrs: {
                      src:
                        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d103565.04666966187!2d137.00402!3d35.789923!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6002efc630324031%3A0xfe84b7487edb1e01!2z44CSNTAxLTQyMDIg5bKQ6Zic55yM6YOh5LiK5biC5YWr5bmh55S65biC5bO277yR77yY4oiS77yR!5e0!3m2!1sja!2sjp!4v1674038082953!5m2!1sja!2sjp",
                      width: "100%",
                      height: "450",
                      allowfullscreen: "",
                      loading: "lazy",
                      referrerpolicy: "no-referrer-when-downgrade"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "gmap_route" }, [
                  _vm._v(
                    "\n                    ◆郡上八幡ICより(所要時間:車約11分)"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    ●八幡IC口交差点を左折、越前街道/国道156号線を南東へ"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    ●城南(交差点)手前で左折、せせらぎ街道/国道256号線を北東へ"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    ●八幡大橋南(交差点)を左折、橋を渡り、せせらぎ街道/国道472号線北へ"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    ●下小野(交差点)を右折、せせらぎ街道/国道472号線を北東へ約4㎞"
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                    ☆対岸に弊社の白い建物が見えてきます\n                  "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c394bd58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c394bd58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcCorpInformation.vue
// module id = null
// module chunks = 